<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_gansu.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_gansu.png'
import list_img1 from '../../images/download/down-gansu1.jpg'
import list_img2 from '../../images/download/down-gansu2.jpg'
import list_img3 from '../../images/download/down-gansu3.jpg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'闲来甘肃麻将',
                size:'86.42',
                load_count:'146',
                desp:'闲来甘肃麻将是一个四个人才能玩的游戏。因其最流行的滑水玩法简单易学、计算方便，而深受广大玩家欢迎。下鱼子等特色玩法更是让游戏刺激畅快。',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=gansu',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=gansu',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:''
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
